<template>
    <div class="flex flex-col lg:flex-row gap-6">
        <table class="w-full table-fixed border-collapse border-solid border-1 border-darkergrey break-words">
            <thead class="text-center text-white text-base md:text-lg">
                <tr class="bg-lightblue">
                    <th class="p-3 border-solid border-1 border-darkergrey">Serum chemistry</th>
                    <th class="p-3 border-solid border-1 border-darkergrey">Result</th>
                    <th class="p-3 border-solid border-1 border-darkergrey">Reference Range</th>
                </tr>
            </thead>

            <tbody class="text-center font-light text-sm md:text-base">
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Creatinine, μmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1644</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">49&ndash;90</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Urea, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">42.2</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">2.5&ndash;9.2</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Total CO2, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">13</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">22&ndash;29</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Chloride, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">107</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">100&ndash;110</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Sodium, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">140</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">136&ndash;145</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Potassium, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">4.7</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">3.4&ndash;5.0</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Anion gap</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">20</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">5&ndash;15</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Lactate, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.8</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.5&ndash;2.2</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Random blood glucose, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">5</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">3.8&ndash;7.8</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Albumin, g/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">31</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">35&ndash;50</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Total calcium, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1.65</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">2.20&ndash;2.60</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Ionized calcium, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.75</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1.15&ndash;1.27</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Phosphorus, mmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">2.92</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.74&ndash;1.52</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Intact parathyroid hormone, ρmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">60.5</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1.9&ndash;8.7</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Total bilirubin, μmol/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">5</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0&ndash;20.4</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Aspartate aminotransferase, U/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">8</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">5&ndash;45</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Alanine aminotransferase, U/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">6</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0&ndash;44</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Alkaline phosphatase, U/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">84</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">38&ndash;150</td>
                </tr>
            </tbody>
        </table>

        <table class="w-full table-fixed border-collapse border-solid border-1 border-darkergrey break-words">
            <thead class="text-center text-white text-base md:text-lg">
                <tr class="bg-lightblue">
                    <th class="p-3 border-solid border-1 border-darkergrey">Serum chemistry</th>
                    <th class="p-3 border-solid border-1 border-darkergrey">Result</th>
                    <th class="p-3 border-solid border-1 border-darkergrey">Reference Range</th>
                </tr>
            </thead>

            <tbody class="text-center font-light text-sm md:text-base">
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">International normalized ratio</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.8&ndash;1.2</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Lactate dehydrogenase, U/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">238</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">120&ndash;230</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">C-reactive protein, mg/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">43.97</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0&ndash;7.99</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey font-semibold text-left" colspan="3">
                        Hematology
                    </td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">White blood cell count, x 109/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">14.45</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">4.5&ndash;11</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Hemoglobin, g/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">87</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">120&ndash;160</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Platelet count, x 109/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">286</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">150&ndash;350</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Haptoglobin, g/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">3.34</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.47&ndash;2.03</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Peripheral smear</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">No schistocytes</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">&ndash;</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Reticulocyte count, x 109/L</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">33</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">28.8&ndash;94.1</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey font-semibold text-left" colspan="3">
                        24-hour urine collection
                    </td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">TV, mL</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1025</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">6.3&ndash;14.6L</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Urine creatinine, mmol/TV</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">1.2</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">40&ndash;320</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Oxalate, μmol/TV</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">319</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">40&ndash;320</td>
                </tr>
                <tr class="bg-white">
                    <td class="p-3 border-solid border-1 border-darkergrey">Citrate, mmol/TV</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">Undetectable</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">≥1.7</td>
                </tr>
                <tr class="bg-grey">
                    <td class="p-3 border-solid border-1 border-darkergrey">Protein, g/TV</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.2</td>
                    <td class="p-3 border-solid border-1 border-darkergrey">0.05&ndash;0.150</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
